/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import AnimatedPage from "../animated/AnimatedPage";
import "./style/contact.css";

function Contact() {
  return (
    <AnimatedPage>
      <div className="contact">
        <ul>
          <li>
            <a href="https://www.linkedin.com/in/mustafaaltas3428/" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-linkedin" aria-hidden="true"></i>
              <span> - Linkedin</span>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/developer_altas" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-twitter" aria-hidden="true"></i>
              <span> - Twitter</span>
            </a>
          </li>
          <li>
            <a href="mailto:mustafaaltas3428@gmail.com" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-google-plus" aria-hidden="true"></i>
              <span> - Google</span>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/xmmuussx/" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-instagram" aria-hidden="true"></i>
              <span> - Instagram</span>
            </a>
          </li>
          <li>
            <a href="https://github.com/MustafaAltas" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-github" aria-hidden="true"></i>
              <span> - Github</span>
            </a>
          </li>
        </ul>
      </div>
    </AnimatedPage>
  );
}

export default Contact;
